import { fetchJson, performPutRequest } from '@atlassian/jira-fetch';
import {
	X2C_SERVICE_URL_PREFIX,
	isSynthetic,
} from '@atlassian/jira-project-create-importer-common';
import { CSV_FILE_UPLOAD_TYPE } from '../../common/constants';
import type { UploadUrlResponse } from '../../common/utils/csv-import-clients/types';

const getX2CFetchUploadUrl = (cloudId: string) =>
	`${X2C_SERVICE_URL_PREFIX}/${cloudId}/import/csv/uploadUrl`;

const getSiteUrl = () => `https://${window.location.hostname}`;

export const fetchUploadUrlAndMigrationId = (
	cloudId: string,
	signal?: AbortSignal,
): Promise<UploadUrlResponse> =>
	fetchJson(getX2CFetchUploadUrl(cloudId), {
		body: JSON.stringify({ url: getSiteUrl() }),
		method: 'POST',
		signal,
		headers: {
			'x-issynthetic-traffic': String(isSynthetic()),
		},
	});

export const uploadFileToS3 = (uploadUrl: string, file: File, signal?: AbortSignal) =>
	performPutRequest(uploadUrl, {
		headers: {
			'Content-Type': CSV_FILE_UPLOAD_TYPE,
			'x-issynthetic-traffic': String(isSynthetic()),
		},
		body: file,
		signal,
	});
